export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      // Service worker configurations
      const serviceWorkers = [
        {
          scriptURL: "/service-worker.js",
          scope: undefined, // Use default scope
          isCustom: true,
        },
        // MoEngage Web SDK script is already included in index.html
        // No need to register additional service worker
      ];

      // Register all service workers
      serviceWorkers.forEach((swConfig) => {
        const options = swConfig.scope ? { scope: swConfig.scope } : {};

        navigator.serviceWorker
          .register(swConfig.scriptURL, options)
          .then((registration) => {
            console.log(
              `${
                swConfig.isCustom ? "Custom" : "MoEngage"
              } Service Worker registered with scope:`,
              registration.scope
            );

            // Only add update logic for custom service worker
            if (swConfig.isCustom) {
              // debug registration scope and scriptURL
              console.log("Registration Scope :" + registration?.scope);
              console.log(
                "Registration Script URL :" + registration?.active?.scriptURL
              );

              // Detect updates to the service worker
              registration.addEventListener("updatefound", () => {
                const newWorker = registration.installing;

                console.log("New Script URL :" + newWorker?.scriptURL);
                // Only attach update logic for YOUR service worker, not OneSignal
                if (
                  newWorker &&
                  newWorker?.scriptURL?.endsWith("/service-worker.js")
                ) {
                  newWorker?.addEventListener("statechange", () => {
                    if (
                      newWorker.state === "installed" &&
                      navigator.serviceWorker.controller
                    ) {
                      if (
                        window.confirm("New content is available. Refresh?")
                      ) {
                        window.location.reload();
                      }
                    }
                  });
                }
              });
            }
          })
          .catch((error) => {
            console.error(
              `${
                swConfig.isCustom ? "Custom" : "MoEngage"
              } Service Worker registration failed:`,
              error
            );
            console.error("Error details:", {
              scriptURL: swConfig.scriptURL,
              scope: swConfig.scope,
              errorName: error.name,
              errorMessage: error.message,
            });
          });
      });
    });
  }
}
